var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, memo } from 'react';
import { twMerge } from 'tailwind-merge';
export const Badge = memo(forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div {...props} ref={ref} className={twMerge('flex flex-initial items-center justify-center px-4 py-2 sm:py-1 sm:px-3 bg-primary text-sm text-center rounded text-white font-bold', className)}/>);
}));
